import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const AlyxInterstitialView = ({ recentlyCompletedMeasure, onAnimationEnd }) => {

    const timeDuration = 6000;

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onAnimationEnd();
        }, timeDuration);

        return () => clearTimeout(timeoutId);
    }, [onAnimationEnd, timeDuration]);

    return (
        <div className="alyxInterstitialWrapper scenery">
            <div>
                <h1 className="heading">Well done!</h1>
                <p className="textContent">
                    You have finished the
                    <br />
                    {recentlyCompletedMeasure}
                    &nbsp;assessment.
                </p>
            </div>
        </div>
    );
};

AlyxInterstitialView.propTypes = {
    recentlyCompletedMeasure: PropTypes.string.isRequired,
    onAnimationEnd: PropTypes.func.isRequired,
};

export default AlyxInterstitialView;
